import { useState, type SyntheticEvent } from "react";
import { Expandable, MenuListContent } from "../LanguageSwitcher.styled";
import LanguageMenu from "src/atoms/LanguageMenu/LanguageMenuNew";

type DesktopMenuListProps = {
  isOpen?: boolean;
  isFooter: boolean;
  svgPrefixId: string;
  showRegion?: boolean;
  showLanguage?: boolean;
  showCurrency?: boolean;
};

function DesktopMenuList({
  isOpen,
  isFooter,
  svgPrefixId,
  showRegion = true,
  showLanguage = true,
  showCurrency = true,
}: DesktopMenuListProps) {
  const [isMask, setIsMask] = useState(true);
  const onScroll = (e: SyntheticEvent) => {
    const target = e.target as HTMLElement;
    const scrolledDown =
      target.scrollHeight - target.scrollTop < target.clientHeight + 10;
    setIsMask(!scrolledDown);
  };

  return (
    <Expandable
      isExpanded={isOpen}
      className={isMask ? "mask" : ""}
      isUpward={isFooter}
    >
      <MenuListContent>
        <LanguageMenu
          svgPrefixId={`desktop-menu-list-${svgPrefixId}`}
          onScroll={onScroll}
          limitHeight={true}
          showRegion={showRegion}
          showLanguage={showLanguage}
          showCurrency={showCurrency}
        />
      </MenuListContent>
    </Expandable>
  );
}

export { DesktopMenuList };
